import * as React from 'react'
import { Container } from './Container'
import networkingImage from './images/networking.jpeg'
import navierImage from './images/navier.png'
import Image from 'next/image'
import { agendaData } from './data/agendaData'

export function Agenda() {
  return (
    <div className="bg-[#EEF2FF]">
      <Container className="relative py-14 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 mb-16 lg:mb-20 items-center">
          <div className="text-primary-dark flex flex-col">
            <h2 className="font-body md:text-6xl lg:text-7xl sm:text-5xl text-4xl font-bold mb-5">
              Agenda
            </h2>
            <time
              dateTime="September 26th, 2023"
              className="font-bold text-2xl text-mx-gray-dark mb-7 lg:mb-14">
              September 26th
            </time>
            <p className="text-xl text-mx-black-light">
              Our 1-day summit is packed with insightful talks, panel
              discussions, and networking opportunities. We focus on the big
              picture, exploring the trends and challenges shaping the future of
              technology and innovation and identifying verticals that are ripe
              for investment.
            </p>
          </div>
          {/* <div className="relative rounded-5xl h-full bg-white p-8">
            {agendaData.map((timeSlot: any, index: number) => (
              <li
                key={timeSlot.start}
                aria-label={`${timeSlot.name} talking about ${timeSlot.description} at ${timeSlot.start} - ${timeSlot.end} PST`}
                className="list-none flex flex-col w-full items-center">
                {index > 0 && (
                  <hr className="mx-auto my-4 h-0 w-64 border-0 border-b border-b-slate-200" />
                )}
                <h4 className="text-lg font-semibold text-primary-dark text-center">
                  {timeSlot.name}
                </h4>
                {timeSlot.description && (
                  <p className="mt-0.5 text-primary-dark text-center">
                    {timeSlot.description}
                  </p>
                )}
                <p className="mt-1 font-mono text-sm text-slate-500">
                  <time dateTime={`2023-09-26T${timeSlot.start}-08:00`}>
                    {timeSlot.start}
                  </time>{' '}
                  -{' '}
                  <time dateTime={`2023-09-26T${timeSlot.end}-08:00`}>
                    {timeSlot.end}
                  </time>{' '}
                  PST
                </p>
              </li>
            ))}
          </div> */}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          <div className="relative rounded-5xl overflow-hidden row-start-2 lg:row-start-auto h-96 lg:h-auto">
            <Image src={networkingImage} alt="" fill className="object-cover" />
          </div>
          <div className="text-primary-dark flex flex-col">
            <h2 className="font-body md:text-6xl lg:text-6xl sm:text-5xl text-4xl font-bold mb-7">
              Networking Opportunities
            </h2>

            <p className="text-xl text-mx-black-light">
              At the MarketX Ventures 2023 Technology & Innovation Summit, we
              believe in the power of connection. That&apos;s why we&apos;ve
              built plenty of networking opportunities into our agenda. From our
              welcome reception to our networking breaks, you&apos;ll have
              plenty of opportunities to connect with fellow attendees, make new
              contacts, and potentially find your next investment opportunity.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 mt-32">
          <div className="text-primary-dark flex flex-col">
            <h2 className="font-body md:text-6xl lg:text-6xl sm:text-5xl text-4xl font-bold mb-7">
              NAVIER showcase
            </h2>

            <p className="text-xl text-mx-black-light">
              We're thrilled to invite you to an immersive showcase featuring
              Navier's cutting-edge boat, a testament to the future of marine
              engineering. As you step aboard, you'll witness the intricate
              blend of advanced technology and sustainable practices that Navier
              has seamlessly integrated. This isn't just a boat; it's a
              revolution in nautical design, emphasizing both performance and
              environmental responsibility.
            </p>
          </div>
          <div className="relative rounded-5xl overflow-hidden row-start-2 lg:row-start-auto h-96 lg:h-auto">
            <Image src={navierImage} alt="" fill className="object-cover" />
          </div>
        </div>
      </Container>
    </div>
  )
}
